<template>
  <div>
    <div class="anamnese-title">
      <span>3/5</span>
      <h4>{{ answers.three.name }}</h4>
    </div>

    <div class="text-box">
      <div class="container">
        <div class="row">
          <div class="col align-items">
            <h4>A. {{ answers.three.a.question }}</h4>
            <div
              v-if="answers.three.a.tooltip != ''"
              class="tooltip-circle"
              data-tooltip-location="left"
              :data-tooltip="answers.three.a.tooltip"
            >
              i
            </div>
          </div>
        </div>
      </div>
      <ul>
        <li :class="answers.three.a.answer == 'Ja' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('three', 'a', 'Ja')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Ja
          </button>
        </li>
        <li :class="answers.three.a.answer == 'Nee' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('three', 'a', 'Nee')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Nee
          </button>
        </li>
      </ul>
      <textarea
        placeholder="Toelichting"
        class="form-control"
        v-model="answers.three.a.explanation"
      ></textarea>
    </div>

    <div class="text-box">
      <div class="container">
        <div class="row">
          <div class="col align-items">
            <h4>B. {{ answers.three.b.question }}</h4>
            <div
              v-if="answers.three.b.tooltip != ''"
              class="tooltip-circle"
              data-tooltip-location="left"
              :data-tooltip="answers.three.b.tooltip"
            >
              i
            </div>
          </div>
        </div>
      </div>
      <ul>
        <li :class="answers.three.b.answer == 'Ja' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('three', 'b', 'Ja')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Ja
          </button>
        </li>
        <li :class="answers.three.b.answer == 'Nee' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('three', 'b', 'Nee')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Nee
          </button>
        </li>
      </ul>
      <textarea
        placeholder="Toelichting"
        class="form-control"
        v-model="answers.three.b.explanation"
      ></textarea>
    </div>

    <div class="text-box">
      <div class="container">
        <div class="row">
          <div class="col align-items">
            <h4>C. {{ answers.three.c.question }}</h4>
            <div
              v-if="answers.three.c.tooltip != ''"
              class="tooltip-circle"
              data-tooltip-location="left"
              :data-tooltip="answers.three.c.tooltip"
            >
              i
            </div>
          </div>
        </div>
      </div>

      <ul>
        <li :class="answers.three.c.answer == 'Ja' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('three', 'c', 'Ja')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Ja
          </button>
        </li>
        <li :class="answers.three.c.answer == 'Nee' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('three', 'c', 'Nee')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Nee
          </button>
        </li>
      </ul>
      <textarea
        placeholder="Toelichting"
        class="form-control"
        v-model="answers.three.c.explanation"
      ></textarea>
    </div>

    <div class="text-box">
      <div class="container">
        <div class="row">
          <div class="col align-items">
            <h4>D. {{ answers.three.d.question }}</h4>
            <div
              v-if="answers.three.d.tooltip != ''"
              class="tooltip-circle"
              data-tooltip-location="left"
              :data-tooltip="answers.three.d.tooltip"
            >
              i
            </div>
          </div>
        </div>
      </div>
      <ul>
        <li :class="answers.three.d.answer == 'Ja' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('three', 'd', 'Ja')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Ja
          </button>
        </li>
        <li :class="answers.three.d.answer == 'Nee' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('three', 'd', 'Nee')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Nee
          </button>
        </li>
      </ul>
      <textarea
        placeholder="Toelichting"
        class="form-control"
        v-model="answers.three.d.explanation"
      ></textarea>
    </div>

    <div class="text-box">
      <div class="container">
        <div class="row">
          <div class="col align-items">
            <h4>E. {{ answers.three.e.question }}</h4>
            <div
              v-if="answers.three.e.tooltip != ''"
              class="tooltip-circle"
              data-tooltip-location="left"
              :data-tooltip="answers.three.e.tooltip"
            >
              i
            </div>
          </div>
        </div>
      </div>
      <ul>
        <li :class="answers.three.e.answer == 'Ja' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('three', 'e', 'Ja')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Ja
          </button>
        </li>
        <li :class="answers.three.e.answer == 'Nee' ? 'active' : ''">
          <button @click.prevent="onClickBoolean('three', 'e', 'Nee')">
            <span>
              <img
                src="images/check-icon.svg"
                alt=""
              />
            </span>
            Nee
          </button>
        </li>
      </ul>
      <textarea
        placeholder="Toelichting"
        class="form-control"
        v-model="answers.three.e.explanation"
      ></textarea>
    </div>
  </div>
</template>

<script>
import useAnswers from "../../composables/useAnswers.js";

export default {
  components: {},
  setup() {
    const { answers } = useAnswers();

    const onClickBoolean = (question, letter, answer) => {
      if (answers.value[question][letter].answer == answer) {
        answers.value[question][letter].answer = "";
      } else {
        answers.value[question][letter].answer = answer;
      }
    };

    return { answers, onClickBoolean };
  },
};
</script>

<style scoped>
@media (min-width: 991px) {
  .anamnese-detail .text-box ul li {
    display: inline-block;
    margin: 0px 8px 8px 8px;
  }
  .anamnese-detail .text-box ul li a {
    min-width: 225px;
  }
}
@media (min-width: 1442px) {
  .anamnese-detail .text-box ul li {
    display: inline-block;
    margin: 0px 8px 8px 8px;
  }
  .anamnese-detail .text-box ul li a {
    min-width: 300px;
  }
}
</style>
